import script from "./primaryFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./primaryFooter.vue?vue&type=script&setup=true&lang=js"

import "./primaryFooter.vue?vue&type=style&index=0&id=2a21094e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a21094e"]])

export default __exports__